/**
 * Botón de guardar reutilizable con icono y estado de carga (spinner).
 */
import { Save } from 'lucide-react';
import styles from './SaveButton.module.css';

interface SaveButtonProps {
    onPress: () => void;
    text?: string;
    containerClassName?: string;
    buttonClassName?: string;
}

export default function SaveButton({ onPress, text = "Guardar", containerClassName, buttonClassName }: SaveButtonProps) {
    return (
        <div className={`${styles.buttonContainer} ${containerClassName ?? ''}`}>
            <button className={`${styles.saveButton} ${buttonClassName ?? ''}`} onClick={onPress}>
                <Save size={18} color="white" className={styles.buttonIcon} />
                <span className={styles.saveButtonText}>{text}</span>
            </button>
        </div>
    );
}
